export default "__VITE_ASSET__9cee9615__"